module.exports = __webpack_public_path__ + "img/plus_btn.54ee9b35.png";